export const BASE_STEP_WIDTH = 230
export const BASE_SMALL_STEP_WIDTH = 180
